import React from 'react'
import { CommandeForm } from './CommandeForm'

export const CommandeItem = (props) => {
    const {location} = props
    const Item = location.state;
    
    return (
        <div>
            <CommandeForm ActionType="Update" MItem={Item} />
        </div>
    )
}
